export default {
    'diagram3a3-4': {
        'diagram-task': 'Drag the points for each argument to the appropriate boxes.',
        'diagram-description': {
            '1': 'But the vast wealth registered by modern capital markets came from technological feats that cannot be repeated',
            '2': 'Thus, investors should risk  backing products that produce new industries and new profits',
            '3': 'Portfolio managers see the returns of the 20th century and project those far into the future',
        },
        'elements': {
            'one': 'Without innovation, faith in the stock market is a kind of cargo cult',
            'two': 'Portfolio managers see the returns of the 20th century and project those far into the future',
            'three': 'Are betting their fortunes on the success rates of yesterday’s companies',
            'four': 'But the vast wealth registered by modern capital markets came from technological feats that cannot be repeated',
            'five': 'Thus, investors should risk backing products that produce new industries and new profits',
        }
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a3/diagram4/i18n/en.js